import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import styles from 'src/pages/car/CSS/SurveyModal.module.css';

const SurveyModal = ({open, onClose, children}) => {
  // ป้องกัน scroll หลังเปิด modal
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className={styles['modal-overlay']}>
      <div
        className={styles['modal-content']}
        onClick={(e) => e.stopPropagation()} // กันคลิกปิดตอนกดข้างใน
      >
        <button className={styles['modal-close']} onClick={onClose}>
          ×
        </button>

        {children}
      </div>
    </div>,
    document.getElementById('modal-root') // ต้องไปใส่ div นี้ใน index.html
  );
};

export default SurveyModal;
